module.exports = __webpack_public_path__ + "img/for-kids-2.2155a9b.webp";